"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Draggable = void 0;

var _react = _interopRequireDefault(require("react"));

var _withTheme = require("../../wrappers/with-theme");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InitialState = {
  size: [0, 0],
  modalPos: [400, 800],
  currPos: [0, 0],
  dragging: false,
  bounds: [0, 0]
};

var Reducer = function Reducer(state, action) {
  var type = action.type,
      payload = _objectWithoutProperties(action, ["type"]);

  switch (type) {
    case "drag-start":
      return _objectSpread(_objectSpread(_objectSpread({}, state), payload), {}, {
        dragging: true
      });

    case "drag-move":
      {
        var currPos = payload.currPos;
        var shift = [currPos[0] - state.currPos[0], currPos[1] - state.currPos[1]];
        return _objectSpread(_objectSpread({}, state), {}, {
          currPos: currPos,
          modalPos: [Math.max(8, Math.min(state.modalPos[0] + shift[0], state.bounds[0] - state.size[0] - 8)), Math.max(8, Math.min(state.modalPos[1] + shift[1], state.bounds[1] - state.size[1] - 8))]
        });
      }

    case "drag-end":
      return _objectSpread(_objectSpread(_objectSpread({}, state), payload), {}, {
        dragging: false
      });

    case "set-modal-pos":
    case "set-bounds":
    case "set-size":
      return _objectSpread(_objectSpread({}, state), payload);

    default:
      return state;
  }
};

var Draggable = function Draggable(_ref) {
  var bounds = _ref.bounds,
      children = _ref.children,
      _ref$toolbar = _ref.toolbar,
      toolbar = _ref$toolbar === void 0 ? [] : _ref$toolbar,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$onDragStart = _ref.onDragStart,
      onDragStart = _ref$onDragStart === void 0 ? null : _ref$onDragStart,
      props = _objectWithoutProperties(_ref, ["bounds", "children", "toolbar", "style", "className", "onDragStart"]);

  var _React$useReducer = _react["default"].useReducer(Reducer, InitialState),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var setModalPos = _react["default"].useCallback(function () {
    if (!(state.bounds[0] || state.bounds[1] || state.size[0] || state.size[1])) return;
    var modalPos = [Math.max(8, Math.min(state.modalPos[0], state.bounds[0] - state.size[0] - 8)), Math.max(8, Math.min(state.modalPos[1], state.bounds[1] - state.size[1] - 8))];

    if (modalPos[0] !== state.modalPos[0] || modalPos[1] !== state.modalPos[1]) {
      dispatch({
        type: "set-modal-pos",
        modalPos: modalPos
      });
    }
  }, [state.bounds, state.size, state.modalPos]);

  _react["default"].useEffect(function () {
    if (state.dragging) return;
    setModalPos();
  }, [state.dragging, setModalPos]);

  _react["default"].useEffect(function () {
    dispatch({
      type: "set-bounds",
      bounds: [bounds.width, bounds.height]
    });
  }, [bounds]);

  var dragMove = _react["default"].useCallback(function (e) {
    e.stopPropagation();
    e.preventDefault();
    dispatch({
      type: "drag-move",
      currPos: [e.clientX, e.clientY]
    });
  }, []);

  _react["default"].useEffect(function () {
    return function () {
      window.removeEventListener("mousemove", dragMove);
    };
  }, [dragMove]);

  var dragStart = _react["default"].useCallback(function (e) {
    var dragEnd = function dragEnd(e) {
      window.removeEventListener("mousemove", dragMove);
      dispatch({
        type: "drag-end"
      });
    };

    if (typeof onDragStart === "function") {
      onDragStart(e);
    }

    window.addEventListener("mousemove", dragMove);
    window.addEventListener("mouseup", dragEnd, {
      once: true
    });
    e.stopPropagation();
    e.preventDefault();
    dispatch({
      type: "drag-start",
      currPos: [e.clientX, e.clientY]
    });
  }, [dragMove, onDragStart]);

  var setSize = _react["default"].useCallback(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    dispatch({
      type: "set-size",
      size: [width, height]
    });
  }, []);

  var ref = _react["default"].useRef();

  (0, _utils.useSetSize)(ref, setSize);
  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    ref: ref
  }, props, {
    className: "\n        absolute inline-block ".concat(theme.sidebarBg, " rounded z-20\n        ").concat(className, "\n      "),
    style: _objectSpread({
      transform: "translate(".concat(state.modalPos[0], "px, ").concat(state.modalPos[1], "px)")
    }, style)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "top-0 right-0 flex justify-end absolute",
    style: {
      transform: "translate(0.5rem, -0.5rem)"
    }
  }, toolbar.map(function (_ref3, i) {
    var icon = _ref3.icon,
        tool = _objectWithoutProperties(_ref3, ["icon"]);

    return /*#__PURE__*/_react["default"].createElement(Tool, _extends({
      key: i
    }, tool, {
      className: "mr-1"
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: "fa ".concat(icon, " text-lg")
    }));
  }), /*#__PURE__*/_react["default"].createElement(DragHandle, {
    dragging: state.dragging,
    onMouseDown: dragStart
  })), children);
};

exports.Draggable = Draggable;

var Tool = function Tool(_ref4) {
  var children = _ref4.children,
      _ref4$className = _ref4.className,
      className = _ref4$className === void 0 ? "" : _ref4$className,
      _ref4$style = _ref4.style,
      style = _ref4$style === void 0 ? {} : _ref4$style,
      props = _objectWithoutProperties(_ref4, ["children", "className", "style"]);

  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    style: _objectSpread({
      cursor: "pointer"
    }, style),
    className: "\n        h-7 w-7 flex items-center justify-center inline-block rounded\n        hover:".concat(theme.bg, " hover:").concat(theme.textInfo, " ").concat(theme.menuBg, "\n        ").concat(className, "\n      ")
  }), children);
};

var DragHandle = function DragHandle(_ref5) {
  var dragging = _ref5.dragging,
      props = _objectWithoutProperties(_ref5, ["dragging"]);

  return /*#__PURE__*/_react["default"].createElement(Tool, _extends({}, props, {
    style: {
      cursor: dragging ? "grabbing" : "pointer"
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "fa fa-bars text-lg"
  }));
};